import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CancelHttpService } from './cancel-http.service';

@Injectable()
export class CancelHttpInterceptor implements HttpInterceptor {

  constructor(private httpCancelService: CancelHttpService,
  ) { }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (!this.httpCancelService.getLogout()) {
      return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
    } else {
      return EMPTY;
    }
  }
}
